module.exports = __webpack_public_path__ + "media/images/svg/signature-84bf5b5a9c2ba4c980b270f6ba16eb68.svg";